module.exports = __webpack_public_path__ + "/img/0d2976a6ecc0c799790d1fc27546fcdd.png";